class HomeBlogList extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.section-home-blog-list__cards');
    this.dots = this.querySelectorAll('.section-home-blog-list__dot');
    this.cards = this.querySelectorAll('.section-home-blog-list__card');

    if (!this.slider || !this.dots.length || !this.cards.length) return;

    this.slider.addEventListener('scroll', this.handleScroll.bind(this));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', this.handleDotClick.bind(this));
    });
  }

  handleScroll() {
    if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
    this.scrollRaf = requestAnimationFrame(() => {
      const scrollLeft = this.slider.scrollLeft;
      const card = this.cards[0];
      if (!card) return;
      const cardWidth = card.offsetWidth;
      const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
      const activeIndex = Math.round(scrollLeft / (cardWidth + gap));
      this.updateDots(activeIndex);
    });
  }

  handleDotClick(event) {
    const index = parseInt(event.target.dataset.index, 10);
    if (isNaN(index)) return;
    const card = this.cards[0];
    if (!card) return;
    const cardWidth = card.offsetWidth;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    this.slider.scrollTo({
      left: index * (cardWidth + gap),
      behavior: 'smooth',
    });
  }

  updateDots(activeIndex) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle(
        'section-home-blog-list__dot--active',
        i === activeIndex
      );
    });
  }
}

if (!customElements.get('home-blog-list')) {
  customElements.define('home-blog-list', HomeBlogList);
}
